import CompanyWorkDetailContent from "../../features/companyWork/widgets/CompanyWorkDetailContent";

function CompanyTaskDetailScreen() {
  return <CompanyWorkDetailContent kind="task" />;
}

export default CompanyTaskDetailScreen;
